import RestClient from './RestClient';
import { CronTask } from '../../models';
import moment from 'moment';

class CronTasks extends RestClient {
    constructor() {
        super({
            "model": CronTask,
            "entryPoint": "cron_task",
            "resource": "cron_task",
            "resources": "cron_tasks",
            "id_field": "_id"
        });
    }
}

const CronTasksApi = new CronTasks();

export default CronTasksApi;
